import React, { ReactNode, useMemo, useState } from 'react';
import ConfirmationDialog from '../../../../../../Dialog/ConfirmationDialog/ConfirmationDialog';
import MenuItem from '../../MenuItem/MenuItem';
import { useRecoilValue } from 'recoil';
import { roleAccessState } from '../../../../../../../atoms/auth/auth.atom';
import { hasRoleAccess } from '../../../../../../../utils/access/access';
import { HttpMethod } from '../../../../../../../domain/Role';
import { SetValues } from '../../../../../../../hooks/useForm/useForm';

export type ModalConfirmationActionAccess = {
  url: string;
  method: HttpMethod;
};

export type ModalConfirmationActionProps = {
  title: string;
  description: string;
  successMessage: string;
  apiUrl: string;
  onSuccess?: (data?: SetValues) => void;
  baseApiUrl?: string;
  httpMethod?: HttpMethod;
  icon?: ReactNode;
  text: string;
  access?: ModalConfirmationActionAccess;
};

export const ModalConfirmationAction = ({
  title,
  description,
  successMessage,
  apiUrl,
  onSuccess,
  baseApiUrl,
  httpMethod,
  icon,
  text,
  access,
}: ModalConfirmationActionProps) => {
  const roleAccessValue = useRecoilValue(roleAccessState);
  const [isOpen, setIsOpen] = useState(false);

  const isDisabled = useMemo(() => {
    if (access) {
      return !hasRoleAccess(roleAccessValue, access.method, access.url);
    }

    if (!baseApiUrl) {
      return false;
    }

    return !hasRoleAccess(roleAccessValue, httpMethod, `${baseApiUrl}/:id`);
  }, [baseApiUrl, access]);

  const handleClick = (e: any) => {
    e.stopPropagation();
    setIsOpen(true);
  };

  return (
    <>
      <MenuItem onClick={handleClick} disabled={isDisabled}>
        {icon}
        {text}
      </MenuItem>
      <ConfirmationDialog
        title={title}
        apiUrl={apiUrl}
        description={description}
        successMessage={successMessage}
        onSuccess={(data) => {
          onSuccess?.(data);
          setIsOpen(false);
        }}
        isOpen={isOpen}
        httpMethod={httpMethod}
        onClose={() => setIsOpen(false)}
      />
    </>
  );
};

export default ModalConfirmationAction;
